export default __webpack_public_path__ + "static/media/benja.206fa6ff.jpg";